import {
  CoalitionProgressBar,
  SingleProductImg,
} from "../CoalitionComplements";
import { ExpiracyDetail, RedeemableLabel } from "../../utils";
import { not_available_horizontal, gift_icon } from "../../pngs";
import "./../CoalitionCards/CardDetail.scss";
import { CoalitionCollapsible } from "../CoalitionCollapsible";

export const CoalitionCardAwardsDetail = ({ balance = 0, card = {} }) => {
  const {
    image,
    title,
    description,
    terms_and_conditions,
    valid_until,
    pay_in_points,
  } = card;
  const redeemable = balance >= pay_in_points;
  return (
    <div className="card-detail">
      <div className="product-image">
        <SingleProductImg load={image} error={not_available_horizontal} />
      </div>
      <RedeemableLabel
        redeemable={redeemable}
        image={gift_icon}
        label={"¡Premio disponible!"}
      />
      <div className="title">{title}</div>
      <div className="description">{description}</div>
      <ExpiracyDetail expiracy={valid_until} />
      <div className="progress">
        <CoalitionProgressBar current={balance} max={pay_in_points} />
      </div>
      <div className="progress-text">Por {pay_in_points} puntos</div>
      <CoalitionCollapsible terms={terms_and_conditions} />
    </div>
  );
};
